import React, {Component} from 'react';
import {Spinner} from 'reactstrap';
import 'assets/sass/dashboard/buy-and-sell/OperationSummary.scss';
import {MoneyField} from "buenLib/components/MoneyField";
import {app} from "app/app";
import {Currency} from "buenLib/domain/Currency";

export class OperationSummary extends Component {
    renderConfirmOperationButton() {
        if (this.props.loading) {
            return <Spinner className="spinner-color"/>;
        } else {
            return (
                <button className="cta-button" onClick={this.props.handleOperationConfirm}>
                    CONFIRMAR {this.props.operationForm.isSell() ? "VENTA" : "COMPRA"}
                </button>
            )
        }
    }

    render() {
        const operationForm = this.props.operationForm;
        return (
            <div className="operation-summary">
                <div className="summary">
                    <div className="summary-buy-and-sell">
                        <div className="label">
                            {operationForm.verboseBidCurrency()} que vas
                            a {operationForm.isBuy() ? " comprar" : " vender"}
                        </div>
                        <div className="quantity">
                            <span className="currency">{operationForm.prettyBidCurrency()}</span>
                            <MoneyField value={operationForm.bidField().value()}
                                        currency={operationForm.bidCurrency()}/>
                        </div>
                    </div>
                    <div className="summary-center">=</div>
                    <div className="summary-buy-and-sell">
                        <div className="label">
                            {operationForm.verboseAskCurrency()} que vas
                            a {operationForm.isSell() ? " recibir" : " pagar"}
                        </div>
                        <div className="quantity">
                            <span className="currency">{operationForm.prettyAskCurrency()}</span>
                            <MoneyField value={operationForm.askField().value()}
                                        currency={operationForm.askCurrency()}/>
                        </div>
                    </div>
                </div>
                <div className="summary-data">
                    <p>Tu cotización <b className="price">
                            <MoneyField
                                value={operationForm.rate().toString()}
                                currency={Currency.priceCurrency(operationForm.bidCurrency(), operationForm.askCurrency())}
                                suffix={` ${operationForm.prettyAskCurrency()}/${operationForm.prettyBidCurrency()}`}
                            />
                        </b>
                    </p>
                    {this.renderFeeCharges(operationForm)}
                    {this.renderTaxCharges(operationForm, "Impuesto PAIS")}
                    {this.renderConfirmOperationButton()}
                    <div className="copy">
                        Al confirmar la operación estoy aceptando los <a
                        href={app.termsAndConditionsUrl()}
                        rel="noopener noreferrer"
                        target="_blank">Términos y Condiciones</a>.
                    </div>
                    <div className="text-center mt-4 mb-4">
                        <p className="text-terms">
                            * Tengo pleno conocimiento de estar operando en la compra y venta de criptomonedas y todas
                            sus implicancias impositivas, financieras y riesgos.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    renderTaxCharges(operationForm, taxLabel) {
        if (operationForm.hasTax()) {
            return (
                <p>
                    {taxLabel} ({operationForm.percentageForTax()}%):&nbsp;
                    <b>
                        <MoneyField
                            defaultValue={0.0}
                            currency={operationForm.askCurrency()}
                            value={operationForm.taxAmount()}
                            prefix={operationForm.prettyFeeCurrency() + " "}/> ({operationForm.verboseFeeCurrency()})
                    </b>
                </p>
            );
        }
    }

    renderFeeCharges(operationForm) {
        if (operationForm.hasFee()) {
            return <p>Comisión de {operationForm.feePercent()}% = {this.renderFee(operationForm)}</p>
        }
    }

    renderFee(operationForm) {
        return (
            <b>
                <MoneyField
                    defaultValue={0.0}
                    currency={operationForm.feeCurrency()}
                    value={operationForm.feeAmount()}
                    prefix={operationForm.prettyFeeCurrency() + " "}/> ({operationForm.verboseFeeCurrency()})
            </b>
        );
    }
}
